module.exports = __webpack_public_path__ + "assets/img/shelp.66c8caff.png";